import { getInitials } from "../../utils/genericFunctions";

const InitialsAvatar = ({
    name,
    size = 40,
    currentTheme = "light",
    fontSize,
}) => {

    const bgColor = currentTheme === "dark" ? "#1E293B" : "#EDE9FE";
    const textColor = currentTheme === "dark" ? "#E0E7FF" : "#5B21B6";
    const initials = getInitials(name);

    return (
        <div
            style={{
                width: size,
                height: size,
                borderRadius: "50%",
                backgroundColor: bgColor,
                color: textColor,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontWeight: 700,
                fontSize: fontSize || Math.floor(size * 0.42),
                userSelect: "none",
                flexShrink: 0,
            }}
        >
            {initials}
        </div>
    );
};

export default InitialsAvatar;
